export interface Task {
  key      : string,
  adminOnly: boolean,
  title    : string,
  message  : string,
  progress : string,
  link     : string
};



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/models/task.model.ts